import React, { useEffect } from 'react';
import './AreaOptions.scss';
import Switch from '../../Switch';

const AreaOptions = ({countImages=0, viewNextImage, updateOptions, listView, hotspotsToggle,hotspotsPosition, admin}) => {
    function toggleList(){
        updateOptions('list', 'visible', true)
    }

    function toggleFilter(){
        updateOptions('filter', 'visible', true)
    }

    function toggleHotspots(e){
        const isChecked = e.currentTarget.checked;
        if (isChecked){
            document.querySelector('body').classList.add('show-hotspots');
        }
        else {
            document.querySelector('body').classList.remove('show-hotspots');
        }
    }

    useEffect(()=>{
        if(hotspotsToggle){
            document.querySelector('body').classList.add('show-hotspots');
        }
    },[])

    const placementClasses = hotspotsToggle && hotspotsPosition ? hotspotsPosition : '';

    return (
        <div className={`area-options ${placementClasses}`}>
            <div onClick={viewNextImage} className={(countImages > 1) ? "btn--small btn--icon" : "hidden"}><i className="fas fa-sync-alt"></i> Rotera vy</div>
            {!admin &&
            <>
                {listView &&
                    <div onClick={toggleList} className="btn--small btn--icon"><i className="fas fa-th-list"></i> Visa lista</div>
                }
                {hotspotsToggle && 
                    <Switch label="Visa/dölj markering" onChange={toggleHotspots}/>
                }
                {!hotspotsToggle && 
                    <div onClick={toggleFilter} className="btn--small btn--icon"><i className="fas fa-sliders-h"></i> Filter</div>
                }
            </>
            }
        </div>
    );
};

export default AreaOptions;